<template>
  <el-select
    :value="value"
    @change="handleSelectChange"
    v-bind="$attrs"
    v-on="$listeners"
    class="select-bank-type"
  >
    <el-option
      v-for="item in bankAccountTypeList"
      :key="item.id"
      :label="item.bankName"
      :value="item.bankName"
    ></el-option>
  </el-select>
</template>

<script>
const loadSize = 50;

export default {
  props: {
    value: {
      type: String
    }
  },

  inheritAttrs: false,

  mounted() {
    this.listenerSelectorScroll();
  },

  data() {
    return {
      bankAccountTypeList: [],

      currentPage: 1,
      pages: 0,
      size: loadSize
    };
  },

  computed: {
    selectedBankDetails() {
      return this.bankAccountTypeList.find(
        item => item.bankName === this.value
      );
    }
  },

  created() {
    this.setBankAccountTypeList();
  },

  methods: {
    handleSelectChange(val) {
      this.$emit("input", val);
    },

    listenerSelectorScroll() {
      const dom = document.getElementsByClassName("select-bank-type")[0];
      const selectBankDom = dom.querySelector(".el-select-dropdown__wrap");
      const that = this;

      selectBankDom.addEventListener("scroll", function() {
        const toggle = this.scrollHeight - this.scrollTop <= this.clientHeight;
        if (toggle) {
          that.loadMoreBankAccountType();
        }
      });
    },

    loadMoreBankAccountType() {
      if (this.currentPage >= this.pages) return;
      this.currentPage++;
      this.setBankAccountTypeList();
    },

    setBankAccountTypeList() {
      this.$api
        .getBankTypes({
          from: this.currentPage,
          size: this.size
        })
        .then(res => {
          this.bankAccountTypeList.push(...res.records);
          this.pages = res.pages;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.select-bank-type {
  width: 100%;
}
</style>